import $ from 'jquery';
import * as SiteApi from './api';
import { displayCreate } from './api';
import { bindCreationGeocoding } from 'modules/saas/customers';

export const displayCreationModal = (customer, onSaved) => {
  displayCreate(customer).then(modal => {
    $(document.body).append(modal);

    const $modal = $('#modal-create-site');
    const $button = $('#submit-button-create-site-form');

    const $form = $('#create-site-form');

    $form.off('submit');

    $button.on('click', evt => {
      evt.preventDefault();

      $button.addClass('loading');

      const data = new FormData($form[0]);

      SiteApi.create(customer, data).then(
        site => {
          $button.removeClass('loading');
          $modal.modal('hide');

          onSaved(site);
        },
        error => {
          console.log('Error attempting to save site', error);
          $button.removeClass('loading');

          error.res.text().then(content => {
            $form.html(content);
            bindCreationGeocoding($form);
          });
        }
      );
    });

    $modal
      .modal({
        onVisible: () => {
          // Bind customer & site geocoding
          bindCreationGeocoding($form);
        },
        onHidden: () => {
          $form.trigger('reset');
          $modal.find('form').trigger('reset');
          $modal.remove();
        },
      })
      .modal('show');
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/sites/modals.js